var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFolderDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 317,
    viewBox: "0 0 397 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_1392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.908 115.261C208.307 115.433 183.363 114.287 160.021 107.753C136.679 101.276 116.026 89.0106 97.2603 74.6818C84.9599 65.3967 73.8038 57.9458 57.8419 59.0921C42.2232 59.8945 27.3483 65.7406 15.2768 75.7135C-4.97596 93.5385 -1.88656 126.437 6.23743 149.593C18.4234 184.44 55.5534 208.685 87.0768 224.446C123.52 242.673 163.568 253.276 203.673 259.351C238.858 264.682 284.055 268.579 314.491 245.596C342.467 224.446 350.191 176.187 343.325 143.575C341.666 133.946 336.517 125.234 328.908 119.158C309.228 104.772 279.935 114.344 257.795 114.86C249.785 115.032 241.261 115.204 232.908 115.261Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.107 1.26123V13.8706",
    stroke: "black",
    strokeWidth: 4.72195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.756 7.56592H119.342",
    stroke: "black",
    strokeWidth: 4.72195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.307 253.047V265.656",
    stroke: "black",
    strokeWidth: 4.72195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.014 259.351H358.6",
    stroke: "black",
    strokeWidth: 4.72195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7922 198.483C19.3941 198.483 20.6528 197.222 20.6528 195.617C20.6528 194.012 19.3941 192.751 17.7922 192.751C16.1903 192.751 14.9316 194.012 14.9316 195.617C14.9316 197.164 16.2475 198.483 17.7922 198.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.486 14.2718C264.087 14.2718 265.346 13.0109 265.346 11.406C265.346 9.80122 264.03 8.54028 262.486 8.54028C260.884 8.54028 259.625 9.80122 259.625 11.406C259.625 13.0109 260.884 14.2718 262.486 14.2718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.847 316.495C242.289 316.495 290.461 313.514 290.461 309.789C290.461 306.063 242.289 303.083 182.847 303.083C123.404 303.083 75.2324 306.063 75.2324 309.789C75.2324 313.457 123.404 316.495 182.847 316.495Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9492 35.5356H256.25C260.14 35.5356 263.859 37.0832 266.605 39.8343C269.351 42.5854 270.896 46.3109 270.896 50.2083V236.483C270.896 240.38 269.351 244.106 266.605 246.857C263.859 249.608 260.14 251.155 256.25 251.155H79.9253C76.035 251.155 72.3163 249.608 69.5701 246.857C66.824 244.106 65.2793 240.38 65.2793 236.483V70.6699L99.9492 35.5356Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.209 126.323H109.045V252.989H270.209V126.323Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2793 70.6699H93.7132C95.3724 70.6699 96.9743 69.9821 98.1757 68.8358C99.3771 67.6322 100.006 66.0273 100.006 64.3652V35.5356L65.2793 70.6699Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.408 85.8584H110.018C103.839 85.8584 98.8047 90.9021 98.8047 97.0922V131.252C98.8047 137.442 103.839 142.486 110.018 142.486H269.408C275.587 142.486 280.622 137.442 280.622 131.252V97.0922C280.622 90.9021 275.587 85.8584 269.408 85.8584Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.756 124.088C135.191 124.088 139.539 119.674 139.539 114.287C139.539 108.842 135.134 104.486 129.756 104.486C124.321 104.486 119.973 108.899 119.973 114.287C119.973 119.732 124.321 124.088 129.756 124.088Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.535 124.088C165.97 124.088 170.318 119.674 170.318 114.287C170.318 108.842 165.913 104.486 160.535 104.486C155.1 104.486 150.752 108.899 150.752 114.287C150.752 119.732 155.1 124.088 160.535 124.088Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.315 124.088C196.75 124.088 201.098 119.674 201.098 114.287C201.098 108.842 196.693 104.486 191.315 104.486C185.88 104.486 181.532 108.899 181.532 114.287C181.475 119.732 185.88 124.088 191.315 124.088Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.408 148.676H110.018C103.839 148.676 98.8047 153.72 98.8047 159.91V194.069C98.8047 200.259 103.839 205.303 110.018 205.303H269.408C275.587 205.303 280.622 200.259 280.622 194.069V159.91C280.622 153.72 275.587 148.676 269.408 148.676Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.756 186.962C135.191 186.962 139.539 182.549 139.539 177.161C139.539 171.716 135.134 167.36 129.756 167.36C124.321 167.36 119.973 171.774 119.973 177.161C119.973 182.549 124.321 186.962 129.756 186.962Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.535 186.962C165.97 186.962 170.318 182.549 170.318 177.161C170.318 171.716 165.913 167.36 160.535 167.36C155.1 167.36 150.752 171.774 150.752 177.161C150.752 182.549 155.1 186.962 160.535 186.962Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.315 186.962C196.75 186.962 201.098 182.549 201.098 177.161C201.098 171.716 196.693 167.36 191.315 167.36C185.88 167.36 181.532 171.774 181.532 177.161C181.475 182.549 185.88 186.962 191.315 186.962Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.408 211.493H110.018C103.839 211.493 98.8047 216.537 98.8047 222.727V256.887C98.8047 263.077 103.839 268.121 110.018 268.121H269.408C275.587 268.121 280.622 263.077 280.622 256.887V222.727C280.622 216.537 275.587 211.493 269.408 211.493Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.756 249.722C135.191 249.722 139.539 245.309 139.539 239.922C139.539 234.477 135.134 230.121 129.756 230.121C124.321 230.121 119.973 234.534 119.973 239.922C119.973 245.366 124.321 249.722 129.756 249.722Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.535 249.722C165.97 249.722 170.318 245.309 170.318 239.922C170.318 234.477 165.913 230.121 160.535 230.121C155.1 230.121 150.752 234.534 150.752 239.922C150.752 245.366 155.1 249.722 160.535 249.722Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.315 249.722C196.75 249.722 201.098 245.309 201.098 239.922C201.098 234.477 196.693 230.121 191.315 230.121C185.88 230.121 181.532 234.534 181.532 239.922C181.475 245.366 185.88 249.722 191.315 249.722Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.827 157.445C317.41 157.445 344.585 130.163 344.585 96.5764C344.585 62.9897 317.41 35.6504 283.827 35.6504C250.244 35.6504 223.068 62.9324 223.068 96.5191C223.068 130.106 250.244 157.445 283.827 157.445Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.02 140.709L343.21 156.929",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38 149.077L336.345 154.35C334.057 156.7 334.171 160.483 336.517 162.718L380.169 204.558C382.514 206.851 386.29 206.736 388.522 204.386L393.556 199.113C395.845 196.763 395.73 192.98 393.385 190.745L349.732 148.905C347.387 146.612 343.611 146.727 341.38 149.077Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 5.55524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_1392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396.702,
    height: 316.494,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolderDarkMode);
export default __webpack_public_path__ + "static/media/EmptyFolderDarkMode.1eca72fc8a29b0104fbbd433a96d94dc.svg";
export { ForwardRef as ReactComponent };